// Keep in sync with Sammandrag.Web/Model/Sport.cs
export enum Sport {
    NotSet = 0,
    Soccer = 1,
    Basketball = 2,
    FieldHockey = 3,
    IceHockey = 4,
    Floorball = 5,
    Handball = 6,
    Volleyball = 7,
    Rugby = 8,
    Cricket = 9,
    Baseball = 10,
    Softball = 11,
    AmericanFootball = 12,
    Badminton = 13,
    Tennis = 14,
    TableTennis = 15,
    BeachVolleyball = 16,
    Other = 17,
}

// All Sport values in declaration order, derived from the enum itself so there's nothing extra to keep in sync.
export const SPORTS: Sport[] = Object.values(Sport).filter((v): v is number => typeof v === 'number');

// Maps a Sport value to its ui.json locale key (e.g. Sport.FieldHockey -> "sport_field_hockey").
// Only used for presentation; everywhere else in the code should use the Sport enum value directly.
export function sportLocaleKey(sport: Sport): string {
    return 'sport_' + Sport[sport].replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
}

